
<template>
  <div>
    <v-select
      label="Question"
      class="white"
      :items="data"
      :item-text="chapterised"
      item-value="id"
      v-model="id"
      :loading="api.isLoading"
      placeholder="Question"
      hide-details
      outlined
    ></v-select>
    <div
      v-if="item && item.question_code && item.question_code.question"
      style="margin-top: 2em"
    >
    <div class="text-right">
 <v-chip x-small class="ma-3" >Sample Question</v-chip>
      </div>
       
      <div class="pa-3">
        <div v-html="item.question_code.question"></div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  props: ["callbackSelect", "callbackError", "chapter"],
  data: () => ({
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    data: [],
    id: null,
    item: null,
  }),

  created() {
    //BOC:[api]
    this.api.method = "get";

    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.data = resp;
      this.item = resp[0];
      this.id = resp[0].id;
    };
    //EOC
  },
  watch: {
    id: function (val) {
      this.id = val;
      this.item = this.$_.find(this.data, { id: this.id });
      this.callbackSelect(this.item);
    },
  },
  methods: {
    fetch() {
      this.api.url =
        this.$api.servers.question +
        "/v2/chapters/" +
        this.chapter.key +
        "/questions?lang=" +
        this.$_getLocale();
      this.$api.fetch(this.api);
    },
    chapterised: (item) => item.name,
  },
  beforeMount() {
    this.fetch();
  },
};
</script>
